import React from 'react';
import { cn } from '../../lib/utils';

export interface ToolbarItemProps {
  label?: string;
  children: React.ReactNode;
  className?: string;
  flex?: boolean;
}

export function ToolbarItem({ label, children, className, flex = false }: ToolbarItemProps) {
  return (
    <div className={cn(
      'flex items-center gap-2 sm:gap-3 3xl:gap-6 w-full sm:w-auto', 
      flex && 'sm:flex-1', 
      className
    )}>
      {label && (
        <span className="text-[9px] sm:text-[10px] 3xl:text-base font-bold uppercase tracking-widest text-muted-foreground whitespace-nowrap">
          {label}
        </span>
      )}
      <div className={cn('min-w-0 flex-1')}>
        {children}
      </div>
    </div>
  );
}

export interface CondensedToolbarProps {
  children: React.ReactNode;
  className?: string;
}

export function CondensedToolbar({ children, className }: CondensedToolbarProps) {
  return (
    <div
      className={cn(
        'flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-x-4 sm:gap-x-6 3xl:gap-x-12 gap-y-3 sm:gap-y-4 3xl:gap-y-8 rounded-lg border border-border/50 bg-muted/10 px-3 py-3 sm:px-4 sm:py-2 3xl:px-8 3xl:py-6',
        className
      )}
    >
      {children}
    </div>
  );
}
